import Button, { ButtonProps } from '@material-ui/core/Button';
import React from 'react';

export const DialogActionButton = (props: ButtonProps) => <Button variant="contained" {...props} />;
